import { render, staticRenderFns } from "./mainSelect.vue?vue&type=template&id=156aaf3b&scoped=true"
import script from "./mainSelect.vue?vue&type=script&lang=js"
export * from "./mainSelect.vue?vue&type=script&lang=js"
import style0 from "./mainSelect.vue?vue&type=style&index=0&id=156aaf3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156aaf3b",
  null
  
)

export default component.exports